import React from 'react';


import Dimension from '../containers/Dimension'
import AnsweredDimension from '../containers/AnsweredDimension'
import Note from '../../modules/notes/containers/index'

const levels = ['', 'Executives','Sr.Managers','Managers','Officers','Individual Contributors']
export default ({activity,showId}) => (
    <div>
    {activity.cps ? Object.entries(activity.cps).map( ([id,cp],i) => <div key={i}>
      <div className="ms-Grid" >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg2 ms-font-xl">{showId ? id : ''} {cp.name}</div>
            <div className="ms-Grid-col ms-lg10">{cp.description}</div>
        </div>
        <div className="ms-Grid-row">
          { levels.map( (level,i) => <div key={i} className="ms-Grid-col ms-lg2">{level}</div>) }
        </div>
        
          {cp.dimensions 
            ? Object.entries(cp.dimensions).map( ([dimensionId,item] ,i) =>
              showId 
                ? <AnsweredDimension key={i}  cpId={id} dimensionId={dimensionId} item={item}  />
                : <Dimension key={i}  cpId={id} dimensionId={dimensionId} item={item}  /> )
            :  <div>Loading</div>}
        <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-lg3 ms-font-xl">Notes</div>
          <div className="ms-Grid-col ms-lg12">
            <Note id={id} />
          </div>  
        </div> 
      </div>
      </div>) :  <span>Loading</span>}

    </div>
)



// WEBPACK FOOTER //
// ./src/activities/components/Competencies.js